import { checkCellValueStyle, NumericalCellValueStyle } from '@toggle/helpers';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useGetV2ThemePerformance } from '~/react-query-hooks/themes/useGetV2ThemePerformance';
import { formatNumber } from '~/views/dashboard/calendar-widget/calendar-event-drawer/drawer-content/utils/number-formatter';

import styles from './RevampOneDayReturnPill.module.scss';

export const RevampOneDayReturnPill = ({ themeId }: { themeId: string }) => {
  const { t } = useTranslation('widget');

  const { data } = useGetV2ThemePerformance({
    ids: themeId,
    intraday: true,
  });

  const value = data?.themes?.[0]?.intraday?.current;
  const numericalStyle = checkCellValueStyle(value);

  if (value === undefined) {
    return null;
  }

  return (
    <div
      className={clsx(styles.rightHeaderWrapper, {
        [styles.positive]: numericalStyle === NumericalCellValueStyle.Positive,
        [styles.negative]: numericalStyle === NumericalCellValueStyle.Negative,
        [styles.neutral]: numericalStyle === NumericalCellValueStyle.Neutral,
      })}
    >
      <span
        className={clsx(styles.rightHeaderReturnValue, {
          [styles.positive]:
            numericalStyle === NumericalCellValueStyle.Positive,
          [styles.negative]:
            numericalStyle === NumericalCellValueStyle.Negative,
          [styles.neutral]: numericalStyle === NumericalCellValueStyle.Neutral,
        })}
      >
        {formatNumber({ isPercentage: false, value })}
      </span>
      <span className={styles.rightHeaderReturnLabel}>
        {t('widget:themeOverview.lastClose')}
      </span>
    </div>
  );
};
